// extracted by mini-css-extract-plugin
export default {"logo":"YI6x6m"};